module.exports = __webpack_public_path__ + "static/erp-img-1-dc50b79bd205908af3d1eea7d3f51fb9.png";